import { RtText } from '@dpa/react-text';
import { RtFrame } from '@dpa/react-frame-pulse';
import classnames from 'classnames/bind';
import { TResponseDataToOptions } from '../../../../_utils/transform-response-data-to-options/_types';
import styles from './index.module.scss';

const cn = classnames.bind(styles);
const BLOCK_NAME = 'Dropdown-option';

type TProps = {
  searchingText: string;
  option: TResponseDataToOptions;
  onChange: (value: TResponseDataToOptions) => void;
};

export const DropdownOption = ({ searchingText, option, onChange }: TProps) => {
  const subLabel = option.subLabel || '';
  const index = subLabel.toLowerCase().indexOf(searchingText.toLowerCase());
  const isIndexNotFound = index === -1;

  if (isIndexNotFound) {
    return (
      <span>
        <RtText specification="main" typography="body-md-regular" as="span">
          {subLabel}
        </RtText>
      </span>
    );
  }

  const handleClick = () => onChange(option);

  const beforeMatch = subLabel.slice(0, index);
  const matchText = subLabel.slice(index, index + searchingText.length);
  const afterMatch = subLabel.slice(index + searchingText.length);

  return (
    <RtFrame
      className={cn(BLOCK_NAME)}
      surface="foundation-pure"
      use="cloudy"
      onClick={handleClick}
    >
      {beforeMatch && (
        <RtText specification="main" typography="body-md-regular" as="span">
          {beforeMatch}
        </RtText>
      )}

      <RtText specification="main" typography="body-md-medium" as="span">
        {matchText}
      </RtText>

      {afterMatch && (
        <RtText specification="main" typography="body-md-regular" as="span">
          {afterMatch}
        </RtText>
      )}
    </RtFrame>
  );
};
